import Icon from '../components/Icon.vue'

Icon.register({"maxcdn":{"width":1792,"height":1792,"paths":[{"d":"M1745 773l-164 763h-334l178-832q13-56-15-88-27-33-83-33h-169l-204 953h-334l204-953h-286l-204 953h-334l204-953-153-327h1276q101 0 189.5 40.5t147.5 113.5q60 73 81 168.5t0 194.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/maxcdn.js
// module id = 829
// module chunks = 0